import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "frame" ]

  load(event) {
    if (!this.hasFrameTarget) return

    const frame = this.frameTarget

    if (frame.hasAttribute("src")) return

    const url = frame.dataset.src
    if (url) {
      setTimeout(() => {
        frame.setAttribute("src", url)
      }, 200)
    }
  }
}
